import { Component, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Equipo } from '@domain/equipo';
import { Pregunta } from '@domain/pregunta';
import * as moment from 'moment';
import * as arrayShuffle from 'array-shuffle';
import { Jugador } from '@domain/jugador';
import { ASSETS } from '@env';
import { DesafioEquipoProvider } from '@providers/desafio-equipo/desafio-equipo';
import { ResultadoTcPage } from '@pages';
import { LoadingProvider } from '@providers/loading/loading';

@IonicPage()
@Component({
  selector: 'page-reto-tc',
  templateUrl: 'reto-tc.html',
})
export class RetoTcPage implements AfterViewInit {

  ICONS_CATEGORIES = ASSETS.ICONS_CATEGORIES;

  equipo: Equipo;
  preguntas: Array<any>;
  jugador: Jugador = new Jugador;

  esIncorrecto = false;
  esCorrecto = false;
  checked = 0;
  disabled = false;

  pregunta: Pregunta = new Pregunta;

  resultados: any = {
    jugador: '',
    equipo: '',
    totalCorrectas: 0,
    totalIncorrectas: 0,
    estadisticas: []
  };

  tiempoInicio: any;
  tiempoRespuesta: string;
  tiempoRespuestaAray: Array<any>;

  readonly PUNTOS_RESPUESTA_CORRECTA = 10;
  readonly PUNTOS_POR_TIEMPO = 2;
  readonly TIEMPO_PARA_RESPONDER = 10;

  readonly AUDIO_OK = 'assets/audios/resp_correcta.wav';
  readonly AUDIO_ERROR = 'assets/audios/resp_wrong.wav';
  private  audio = new Audio();

  puntosGanados = 0;

  indexOptionSelected: number;

  @ViewChild('timer', { read: ElementRef }) timer: ElementRef;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private desafioEquipoProvider: DesafioEquipoProvider,
    private loadingProvider: LoadingProvider
  ) {
    this.equipo = this.navParams.get('equipo');
    this.jugador = this.navParams.get('jugador');
    this.preguntas = this.navParams.get('preguntas');

    this.resultados.equipo = this.equipo._id;
    this.resultados.jugador = this.jugador._id;
  }

  ionViewDidLoad() {
  }

  validaPregunta(esValida: boolean, pregunta: any, index: number) {
    this.indexOptionSelected = index;
    this.esCorrecto = esValida;
    this.esIncorrecto = !esValida;
    this.disabled = true;
    this.timer.nativeElement.style.animationPlayState = 'paused';
    this.puntosGanados = 0;
    this.obtenTiempoRespuesta();

    if (esValida) {
      this.resultados.totalCorrectas++;
      this.calculaPuntos();
      this.audio.src = this.AUDIO_OK;
    } else {
      this.resultados.totalIncorrectas++;
      this.audio.src = this.AUDIO_ERROR;
    }

    this.audio.load();
    this.audio.play();

    let tiempo: any = (+this.tiempoRespuestaAray[0] * 60) + (+this.tiempoRespuestaAray[1]);
    tiempo = tiempo + '.' + + +this.tiempoRespuestaAray[2];

    this.resultados.estadisticas.push({
      pregunta: pregunta._id,
      tiempo: +tiempo,
      puntos: this.puntosGanados,
      esCorrecta: esValida
    });
  }

  siguiente() {
    let siguientePregunta = this.preguntas.pop();

    if (!siguientePregunta) {
      this.loadingProvider.show(true);
      this.desafioEquipoProvider.guardaRonda(this.equipo.area._id, this.equipo._id, this.jugador._id, this.resultados.estadisticas)
        .then(response => {
          this.navCtrl.setRoot(ResultadoTcPage, {
            equipo: this.equipo,
            jugador: this.jugador,
            preguntas: this.preguntas,
            resultados: this.resultados
          })
          .then( _ => this.loadingProvider.show(false) );
        });
    } else {
      let _arrayOpciones = [
        siguientePregunta.opcion1,
        siguientePregunta.opcion2,
        siguientePregunta.opcion3,
        siguientePregunta.opcion4,
      ];
      siguientePregunta.opciones = arrayShuffle(_arrayOpciones);
      siguientePregunta.opciones = arrayShuffle(siguientePregunta.opciones);

      this.tiempoInicio = moment();
      this.pregunta = siguientePregunta;
      this.esIncorrecto = false;
      this.esCorrecto = false;
      this.checked = 0;
      this.disabled = false;
      this.tiempoRespuesta = '';
      this.timer.nativeElement.style.animationPlayState = '';
      this.timer.nativeElement.style.animation = '';
      setTimeout(() => {
        this.timer.nativeElement.style.animation = 'countdown ' + this.TIEMPO_PARA_RESPONDER + 's linear  forwards';
      });

    }
  }

  ngAfterViewInit() {
    this.siguiente();
  }

  obtenTiempoRespuesta() {
    let now = moment();
    let then = this.tiempoInicio;

    let time = moment.utc(moment(now, "DD/MM/YYYY HH:mm:ss.S").diff(moment(then, "DD/MM/YYYY HH:mm:ss.S"))).format("m.s.S");
    this.tiempoRespuestaAray = time.toString().split('.');

    this.tiempoRespuesta = +this.tiempoRespuestaAray[0] === 0 ?
      this.tiempoRespuestaAray[1] + '.' + this.tiempoRespuestaAray[2] + 's' :
      this.tiempoRespuestaAray[0] + '.' + this.tiempoRespuestaAray[1] + 'm';
  }

  calculaPuntos() {
    this.puntosGanados = this.PUNTOS_RESPUESTA_CORRECTA;

    let m = +this.tiempoRespuestaAray[0];
    let s = +this.tiempoRespuestaAray[1];
    let ss = +this.tiempoRespuestaAray[2];

    let total = ((m * 60) + s) + (ss * .10);

    const fraccion = this.TIEMPO_PARA_RESPONDER / 4;

    if (total >= 0 && total < fraccion) {
      this.puntosGanados += this.PUNTOS_POR_TIEMPO * 4;
    }

    if (total >= fraccion && total < fraccion * 2) {
      this.puntosGanados += this.PUNTOS_POR_TIEMPO * 3;
    }

    if (total >= fraccion * 2 && total < fraccion * 3) {
      this.puntosGanados += this.PUNTOS_POR_TIEMPO * 2;
    }

    if (total >= fraccion * 3 && total < fraccion * 4) {
      this.puntosGanados += this.PUNTOS_POR_TIEMPO;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/team-challenge/reto-tc/reto-tc.ts